import { render, staticRenderFns } from "./FormSubconPayment.vue?vue&type=template&id=5a6c483b"
import script from "./FormSubconPayment.vue?vue&type=script&lang=js"
export * from "./FormSubconPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports